// extracted by css-extract-rspack-plugin
export default {"productSliderSkeletonBorder":"product-detail-fragment__SkeletonTile_productSliderSkeletonBorder__vchs5","w30":"product-detail-fragment__SkeletonTile_w30__auUXf"};